import React from 'react'

import { Typography } from 'antd'

import styles from './styles.module.less'

const statuses = {
  PENDING: {
    color: 'gray',
    text: 'Na Fila'
  },
  PROCESSING: {
    color: 'blue',
    text: 'Processando'
  },
  COMPLETED: {
    color: 'green',
    text: 'Disponível'
  },
  FAILED: {
    color: 'red',
    text: 'Erro'
  }
}

export const Status = ({ status }) => {
  const currentStatus = statuses[status] || statuses.PENDING

  return (
    <div className={styles[`status-wrapper-${currentStatus.color}`]}>
      <Typography.Text>{currentStatus.text}</Typography.Text>
    </div>
  )
}
